import {makeAutoObservable} from 'mobx';
import LibraryRepository from '../../../data/repositories/LibraryRepository';
import {StoryblocksMediaItem} from '../../../data/models/Storyblocks/StoryblocksMediaItem';

class StoryblocksStore {
  private libraryRepo = new LibraryRepository();

  public mediaItems: StoryblocksMediaItem[] = [];
  public hasMore = true;
  public totalResults = 0;

  constructor() {
    makeAutoObservable(this);
  }

  public reset() {
    this.mediaItems = [];
    this.hasMore = true;
    this.totalResults = 0;
  }

  public async appendStoryblocksMedia(
    organizationId: string,
    chunkId: string | null | undefined,
    page: number,
    pageSize: number,
    search: string,
  ): Promise<void> {
    const response = await this.libraryRepo.getStoryblocksMedia(
      organizationId,
      chunkId,
      page,
      pageSize,
      search,
    );

    if (response.success && response.data) {
      const nextItems = [...this.mediaItems, ...response.data.results];
      this.mediaItems = nextItems;
      this.totalResults = response.data.total_results;
      const fetchedCount = response.data.results.length;
      // No more data if: no items returned, got less than requested, or reached total
      this.hasMore =
        fetchedCount > 0 &&
        fetchedCount === pageSize &&
        nextItems.length < response.data.total_results;
    } else {
      this.hasMore = false;
    }
  }

  public async changeChunkToStoryblocksMedia(
    organizationId: string,
    mediaFileId: string,
    aiVideoChunkId: string,
    storyBlocksVideoId: string,
  ) {
    await this.libraryRepo.changeChunkToStoryblocksMedia(
      organizationId,
      mediaFileId,
      aiVideoChunkId,
      storyBlocksVideoId,
    );
  }
}

export default StoryblocksStore;
